module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-woman-40_320b54846494ef769d297cdba3cf95b4.jpg";